import { render, staticRenderFns } from "./subAccountDetail.vue?vue&type=template&id=5e31745f&scoped=true&"
import script from "./subAccountDetail.vue?vue&type=script&lang=js&"
export * from "./subAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./subAccountDetail.vue?vue&type=style&index=0&id=5e31745f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31745f",
  null
  
)

export default component.exports